import { branch, renderComponent } from 'recompose';
import { LoadingPage } from 'components/core/LoadingPage';

export default (branchFn) => branch(branchFn, renderComponent(LoadingPage));
